export default __webpack_public_path__ + "static/media/menu_news_okara.0bdaae59.svg";